"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _configureFilterModal = require("./configureFilterModal.style");
var _Icon = _interopRequireDefault(require("../../Icon"));
var _Button = _interopRequireDefault(require("../../Button"));
var _Tooltip = _interopRequireDefault(require("../../Tooltip"));
var _Input = _interopRequireDefault(require("../../Input"));
function ConfigureFilterModal(_ref) {
  let {
    defaultColumns = [],
    configuration = {},
    onSaveColumnConfig,
    onModalClose
  } = _ref;
  const [currentConfigColumns, setCurrentConfigColumns] = (0, _react.useState)(JSON.parse(JSON.stringify(configuration)));
  const [filteredCurrentConfigColumnsIndex, setFilteredCurrentConfigColumnsIndex] = (0, _react.useState)(Object.keys(configuration));
  const [searchTerm, setSearchTerm] = (0, _react.useState)('');
  const [visibleNumber, setVisibleNumber] = (0, _react.useState)(0);
  (0, _react.useEffect)(() => {
    setFilteredCurrentConfigColumnsIndex(Object.keys(currentConfigColumns).filter(i => i.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1));
  }, [searchTerm, currentConfigColumns]);
  const onClose = () => {
    setSearchTerm('');
    onModalClose();
  };
  const saveColumnConfig = () => {
    const newConfiguration = JSON.parse(JSON.stringify(currentConfigColumns));
    onSaveColumnConfig(newConfiguration);
    onModalClose();
    setSearchTerm('');
  };
  const restoreDefaults = () => {
    const newConfiguration = (0, _extends2["default"])({}, currentConfigColumns);
    Object.keys(newConfiguration).forEach(item => {
      newConfiguration[item].isVisible = defaultColumns.indexOf(item) > -1;
    });
    setCurrentConfigColumns(newConfiguration);
  };
  const onTextChange = event => {
    setSearchTerm(event.target.value);
  };
  const onTextClear = () => {
    setSearchTerm('');
  };
  const toggleColumnVisibility = item => {
    let count = 0;
    Object.keys(currentConfigColumns).forEach(item => {
      if (currentConfigColumns[item].isVisible) {
        count++;
      }
    });
    const updateConfigColumns = (0, _extends2["default"])({}, currentConfigColumns);
    setVisibleNumber(count);
    if (count < 30) {
      updateConfigColumns[item].isVisible = !currentConfigColumns[item].isVisible;
    } else {
      updateConfigColumns[item].isVisible = false;
    }
    setCurrentConfigColumns(updateConfigColumns);
  };
  return (0, _jsxRuntime.jsx)(_configureFilterModal.ConfigureModal, (0, _extends2["default"])({
    heading: "Configure Filter Columns",
    open: true,
    zindex: 999999,
    showCloseIcon: true,
    dimension: "medium",
    onClose: () => onClose(),
    actions: {
      primaryAction: (0, _jsxRuntime.jsx)(_Button["default"], {
        label: "Apply",
        disabled: false,
        onClick: saveColumnConfig
      }),
      secondaryAction: (0, _jsxRuntime.jsx)(_Button["default"], {
        variant: "outlined",
        label: "Cancel",
        onClick: onClose
      }),
      tertiaryAction: (0, _jsxRuntime.jsxs)(_configureFilterModal.RestoreButton, (0, _extends2["default"])({
        onClick: restoreDefaults
      }, {
        children: [(0, _jsxRuntime.jsx)(_Icon["default"], {
          name: "trash",
          size: "20"
        }), (0, _jsxRuntime.jsx)(_configureFilterModal.RestoreButtonLabel, {
          children: "Restore Default"
        })]
      }))
    }
  }, {
    children: (0, _jsxRuntime.jsxs)(_configureFilterModal.Body, {
      children: [(0, _jsxRuntime.jsxs)(_configureFilterModal.LeftContent, {
        children: [(0, _jsxRuntime.jsx)(_configureFilterModal.ContentHeader, (0, _extends2["default"])({
          variant: "body2",
          fontStyle: "normal"
        }, {
          children: "Default Filters"
        })), (0, _jsxRuntime.jsx)(_configureFilterModal.LeftContentBody, (0, _extends2["default"])({
          variant: "body2",
          fontStyle: "normal"
        }, {
          children: Object.keys(configuration).map((fieldMapping, key) => configuration[fieldMapping].isDefault && (0, _jsxRuntime.jsx)(_configureFilterModal.LeftContentBodyValue, {
            children: fieldMapping
          }, key))
        }))]
      }), (0, _jsxRuntime.jsxs)(_configureFilterModal.RightContent, {
        children: [(0, _jsxRuntime.jsx)(_configureFilterModal.RightContentHeader, (0, _extends2["default"])({
          variant: "body2",
          fontStyle: "normal"
        }, {
          children: "Configuration"
        })), (0, _jsxRuntime.jsx)(_configureFilterModal.RightContentSearch, {
          children: (0, _jsxRuntime.jsx)(_Input["default"], {
            id: "congifure-column-modals",
            placeholder: "Search for column",
            icon: "magnifying-glass",
            iconPosition: "left",
            value: searchTerm,
            clearButton: true,
            onChange: e => onTextChange(e),
            onClear: onTextClear
          })
        }), (0, _jsxRuntime.jsx)(_configureFilterModal.RightContentBody, {
          children: filteredCurrentConfigColumnsIndex.map((item, key) => (0, _jsxRuntime.jsxs)(_configureFilterModal.RightContentRow, {
            children: [(0, _jsxRuntime.jsx)(_configureFilterModal.RightContentItem, {
              children: item || 'N/A'
            }), (0, _jsxRuntime.jsx)(_configureFilterModal.RightContentRowIcons, {
              children: currentConfigColumns[item].isVisible ? (0, _jsxRuntime.jsx)(_configureFilterModal.ColumnIcon, {
                name: "eye",
                size: "24",
                isVisible: true,
                onClick: () => toggleColumnVisibility(item)
              }) : (0, _jsxRuntime.jsx)(_Tooltip["default"], (0, _extends2["default"])({
                appearance: "inverse",
                content: visibleNumber >= 30 ? 'Cannot show more than 30 columns' : '',
                position: "top",
                width: "auto",
                zIndex: 999999
              }, {
                children: (0, _jsxRuntime.jsx)(_configureFilterModal.ColumnIcon, {
                  name: "eye-slash",
                  size: "24",
                  onClick: () => toggleColumnVisibility(item)
                })
              }))
            })]
          }, key))
        })]
      })]
    })
  }));
}
var _default = exports["default"] = ConfigureFilterModal;